import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { store, persistor } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import "react-quill/dist/quill.snow.css";
import "typeface-roboto";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
      <ToastContainer/>
    </PersistGate>
  </Provider>
);
